<template>
  <div>
    <UserForm ref="refUserForm" :userData="userData" />

    <Address ref="refAddress" :userData="userData" @openSearch="openSearch" />

    <FarmForm ref="refFarmForm" :userData="userData" />

    <!-- 우편번호 -->
    <AddressSearchDaum
      ref="refAddressSearch"
      @searchCompleteUse="searchCompleteUseHandler"
    />
  </div>
</template>

<script>
import AddressSearchDaum from "@/components/AddressSearchDaum.vue";
import UserForm from "./userForm/UserForm.vue";
import Address from "./userForm/Address.vue";
import FarmForm from "./userForm/FarmForm.vue";

export default {
  components: {
    UserForm,
    Address,
    FarmForm,
    AddressSearchDaum,
  },
  props: {
    userData: {
      type: Object,
    },
  },
  methods: {
    async openSearch() {
      this.$refs.refAddressSearch.showModal();
    },
    searchCompleteUseHandler(e) {
      // console.log("e.addr", e.addr);
      if (e.addr !== "" && e.addr !== null) {
        let addrArray = e.addr.split(" ");
        let siDo = addrArray.length > 0 ? addrArray[0] : "";
        let guGun = addrArray.length > 1 ? addrArray[1] : "";
        console.log("e.addr", siDo, guGun);
        this.userData.address.siDo = siDo;
        this.userData.address.guGun = guGun;
        this.userData.isAddressSearch = true;
      }

      this.userData.address.zipcode = e.zip;
      this.userData.address.city = e.addr;
      this.userData.address.street = "";
      setTimeout(() => {
        this.$refs.refAddress.$refs.refStreet.focus();
      }, 300);

      console.log("this.userData", this.data);
    },
  },
};
</script>